import React, { useEffect, useMemo, useState } from "react";
import MerchantEnrollmentAPI from "../../api/MerchantEnrollmentAPI";
import CompanyInformationForm from "../../components/Enrollment/CompanyInformationForm";
import EmployeesInformationForm from "../../components/Enrollment/EmployeesInformationForm";
import InformationConfirmation from "../../components/Enrollment/InformationConfirmation";
import ResponsePage from "../../components/MerchantEnrollment/ResponsePage";
import { useDispatch, useSelector } from "react-redux";
import {
  renderField,
  renderFieldCompany,
  renderFieldCompanyImages,
} from "../../utils/renderFields";
import { settingData } from "../../features/legalEnrollmentSlice";
import "../../utils/Style/pages/OwnerShipProfile.scss";
import CountryTransferPopup from "../../components/countryTransferPopup";
import SaveEnrollementPopup from "../../components/SaveEnrollementPopup";

function FormsTemplate({ handleNext, currentStep, setRerender }) {
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState({});
  const [modalShow, setModalShow] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalDes, setModalDes] = useState("");
  const [infoShowing, setInfoShowing] = useState({});
  const [shareholder, setShareHolder] = useState(false);
  const [modalMode, setModalMode] = useState(null);
  const [modalPayload, setModalPayload] = useState(null);
  const [modifiedData, setmodifiedData] = useState({});
  const [targetId, setTargetId] = useState(null);
  const [originalValue, setOriginalValue] = useState(null);
  const [didPick, setDidPick] = useState(false);
  const [outsideSelections, setOutsideSelections] = useState({});
  const [extraOwners, setExtraOwners] = useState(0);
  const [ownerIdxMap, setOwnerIdxMap] = useState({});

  const verificationid = useSelector(
    (s) => s?.legalEnrollment?.verificationRef
  );

  const initialStepId = useSelector((s) => s?.legalEnrollment?.initialStepId);

  const remoteId = useSelector((s) => s?.legalEnrollment?.remoteID);

  const finalStep = useSelector((s) => s?.legalEnrollment?.finalStep);
  const remoteID = useSelector((s) => s?.legalEnrollment?.remoteID);
  const countries = useSelector(
    (s) => s?.legalEnrollment?.countries?.countries
  );

  const allcountries = useSelector((s) => s?.legalEnrollment?.allcountries);
  const stepid = useSelector((s) => s?.legalEnrollment?.stepid);
  const corporatedata = useSelector((s) => s?.legalEnrollment?.corporatedata);
  const stepsRedux = useSelector(
    (s) => s?.legalEnrollment?.performcorporateaction?.steps
  );
  const getfieldByStepId = useSelector(
    (s) => s?.legalEnrollment?.getfieldByStepId
  );

  let currentStepId = stepid;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [currentStepId]);

  const {
    CorporateAutoFillData,
    autofillData,
    employeesList,
    GetFieldsByStepId,
    SaveFieldValue,
    SaveCorporateEnrollmentEntityData,
    uploadImage,
  } = MerchantEnrollmentAPI();

  const removeShareholder = (parentId, suffix) => {
    setmodifiedData((prevMod) => {
      const newMod = { ...prevMod };

      // 🔑 check against prevMod
      const cameFromApi = !Object.keys(prevMod).some((key) =>
        key.endsWith(`_${suffix}`)
      );

      if (cameFromApi) {
        // collect fields for removal
        const removedFields = Object.entries(formData)
          .filter(([key]) => key.endsWith(`_${suffix}`))
          .flatMap(([key, val]) => {
            const id = baseIdNum(key);
            const groupId = computeGroupIdForKey(key);

            if (Array.isArray(val)) {
              return val.filter(Boolean).map((item) => ({
                id,
                value: String(item),
                groupId,
                statusId: 2,
              }));
            }

            return [
              {
                id,
                value: String(val ?? ""),
                groupId,
                statusId: 2,
              },
            ];
          });

        if (removedFields.length > 0) {
          SaveFieldValue(removedFields, currentStepId, verificationid, true);
        }
      }

      // always clean up local modified data
      Object.keys(newMod).forEach((key) => {
        if (key.endsWith(`_${suffix}`)) delete newMod[key];
      });

      return newMod;
    });

    // cleanup for formData, errors, selections, etc.
    setFormData((prevData) => {
      const newData = { ...prevData };
      Object.keys(newData).forEach((key) => {
        if (key.endsWith(`_${suffix}`)) delete newData[key];
      });
      return newData;
    });

    setErrors((prevErrors) => {
      const newErr = { ...prevErrors };
      Object.keys(newErr).forEach((key) => {
        if (key.endsWith(`_${suffix}`)) delete newErr[key];
      });
      return newErr;
    });

    setOutsideSelections((prevSel) => {
      const newSel = { ...prevSel };
      Object.keys(newSel).forEach((key) => {
        if (key.endsWith(`_${suffix}`)) delete newSel[key];
      });
      return newSel;
    });

    setMessage?.((prev) => {
      const m = { ...(prev || {}) };
      Object.keys(m).forEach((k) => {
        if (k.endsWith(`_${suffix}`)) delete m[k];
      });
      return m;
    });

    setOwnerIdxMap((prev) => {
      const list = prev[parentId] || [];
      return { ...prev, [parentId]: list.filter((i) => i !== suffix) };
    });
  };

  const addShareholder = (parentId, linkedIds) => {
    let nextSuffix; // <-- define outside so we can use it below

    setOwnerIdxMap((prev) => {
      const list = prev[parentId] || [];
      nextSuffix = (list[list.length - 1] ?? 0) + 1; // 1,2,3,...
      return { ...prev, [parentId]: [...list, nextSuffix] };
    });

    // seed blanks so renderers don't fallback
    setFormData((p) => {
      const blanks = {};
      linkedIds.forEach((id) => (blanks[`${id}_${nextSuffix}`] = ""));
      return { ...p, ...blanks };
    });

    setErrors?.((p) => {
      const copy = { ...(p || {}) };
      linkedIds.forEach((id) => delete copy[`${id}_${nextSuffix}`]);
      return copy;
    });

    setmodifiedData?.((p) => {
      const copy = { ...(p || {}) };
      linkedIds.forEach((id) => delete copy[`${id}_${nextSuffix}`]);
      return copy;
    });

    // seed upload messages for the new fields
    setMessage?.((p) => {
      const copy = { ...(p || {}) };
      // If you only want messages for image fields, filter:
      // linkedIds.filter((id) => fieldsIndex[id]?.type === 21).forEach(...)
      linkedIds.forEach((id) => {
        copy[`${id}_${nextSuffix}`] = ""; // ready for "Uploading..." / "Uploading Successfully"
      });
      return copy;
    });
  };

  const cloneForOwner = (lf, idx) => ({
    ...lf,
    id: `${lf.id}_${idx}`, // unique id in JSX and formData
    value: "", // force blank, so no fallback to original value
  });

  useEffect(() => {
    const handleWheel = (event) => event.preventDefault();
    const inputElement = document.getElementById("number-input");
    inputElement?.addEventListener("wheel", handleWheel, { passive: false });
    return () => inputElement?.removeEventListener("wheel", handleWheel);
  }, []);

  // useEffect(() => {
  //   CorporateAutoFillData();
  // }, []);

  useEffect(() => {
    if (!verificationid || currentStepId == null) return;

    (async () => {
      if (currentStepId !== 28) {
        await GetFieldsByStepId(currentStepId, verificationid);
      } else {
        await CorporateAutoFillData(true);
      }
    })();
  }, [currentStepId, verificationid]);

  useEffect(() => {
    const handleWheel = (event) => event.preventDefault();
    const el = document.getElementById("number-input");
    el?.addEventListener("wheel", handleWheel, { passive: false });
    return () =>
      el?.removeEventListener("wheel", handleWheel, { passive: false });
  }, []);

  const norm = (f) => ({ ...f, id: f.id ?? f.fieldId });

  useEffect(() => {
    // helper: try parse [{"Value":"...","GroupID":"..."}]
    const asValueList = (v) => {
      if (typeof v !== "string") return null;
      try {
        const arr = JSON.parse(v);
        return Array.isArray(arr) ? arr : null;
      } catch {
        return null;
      }
    };

    //     const nextForm = {};
    //     let maxOrdinal = 1; // to rebuild ownerIdxList [1..max-1]

    const nextForm = {};
    // Track the maximum ordinal for each parent (for backwards compatibility)
    const perParentMax = {};
    // Track the specific ordinals (e.g., 2,3,4...) that have actual values for each parent
    const perParentOrdinals = {};

    // 1) Pre-fill from corporate summary if present (keeps previous behavior)
    if (corporatedata?.groupedFields) {
      const flat = Object.values(corporatedata.groupedFields).flat();
      flat.forEach((f) => {
        const id = String(f.fieldId ?? f.id);
        const raw = (f.value ?? "").toString().trim();
        const def = f.type === 6 ? String(f.options?.[0]?.optionId ?? "") : "";
        nextForm[id] = raw !== "" ? raw : def;
      });
    }

    // 2) Parse the active step fields, respecting GroupID
    const stepFields = getfieldByStepId?.fields ?? [];
    stepFields.forEach((f) => {
      const idBase = String(f.id);
      const list = asValueList(f.value);

      if (list) {
        list.forEach((item) => {
          const val = (item?.Value ?? "").toString();
          const gid = (item?.GroupID ?? "").toString(); // e.g. "161_2" or "194_3"
          let ordinal = 1;
          const m = gid.match(/_(\d+)$/);
          if (m) ordinal = Number(m[1]) || 1;

          // the key to store the value in formData (unchanged)
          const key = ordinal === 1 ? idBase : `${idBase}_${ordinal - 1}`;
          nextForm[key] = val;

          // NEW: always count clones under the visible parent
          const childIdNum = Number(idBase);
          const preferredParent = linkedParentByChild[childIdNum];
          if (preferredParent) {
            // record maximum ordinal to preserve original logic if needed
            perParentMax[preferredParent] = Math.max(
              perParentMax[preferredParent] || 1,
              ordinal
            );
            // record exactly which ordinals have values for this parent
            if (!perParentOrdinals[preferredParent]) {
              perParentOrdinals[preferredParent] = new Set();
            }
            perParentOrdinals[preferredParent].add(ordinal);
          }
        });
      } else {
        // non-grouped single value (or empty)
        const raw = (f.value ?? "").toString().trim();
        const def = f.type === 6 ? String(f.options?.[0]?.optionId ?? "") : "";
        nextForm[idBase] = raw !== "" ? raw : def;
      }
    });

    // 3) Rebuild ownerIdxList so extra groups render again
    // original block = ordinal 1 (no suffix); extras = ordinals 2..maxOrdinal => suffixes 1..(max-1)
    //     const extras = [];
    //     for (let sfx = 1; sfx <= maxOrdinal - 1; sfx++) extras.push(sfx);
    //     setOwnerIdxList(extras);

    const map = {};
    Object.entries(perParentMax).forEach(([parentId, maxOrd]) => {
      const pid = Number(parentId);
      const max = Number(maxOrd) || 1;
      const ordSet = perParentOrdinals[pid] || null;
      let arr = [];
      if (ordSet && ordSet.size) {
        // include only the ordinals that actually have values (omit ordinal 1)
        arr = Array.from(ordSet)
          .filter((ord) => Number(ord) > 1)
          .map((ord) => Number(ord) - 1)
          .sort((a, b) => a - b);
      } else {
        // fallback: include all suffixes up to max-1
        for (let sfx = 1; sfx <= max - 1; sfx++) {
          arr.push(sfx);
        }
      }
      map[pid] = arr;
    });
    setOwnerIdxMap(map);
    setFormData(nextForm);
    setmodifiedData({});
  }, [corporatedata, getfieldByStepId]);

  const openCountrySlot = (field, slotIndex) => {
    setModalMode("COUNTRIES");
    setModalTitle("Country of Transfers / Origin of Funds");
    setModalDes("");
    setModalPayload({
      type: "outsideCountry",
      fieldId: field,
      slotIndex,
    });
    setDidPick(false);
    setModalShow(true);
  };

  const MAX_BYTES = 10 * 1024 * 1024; 

  const handleUploadChange = async (e) => {
    const { name, files } = e.target;
    const file = files?.[0] || null;
    if (!file) return;

    if (file.size > MAX_BYTES) {
      e.target.value = ""; // reset the input
      setMessage(prev => ({ ...prev, [name]: "" }));
      setErrors(prev => ({ ...prev, [name]: "File must be smaller than 10 MB." }));
      return;
    }

    try {
      setMessage((prev) => ({ ...prev, [name]: "Uploading..." }));
      setErrors((prev) => {
        const next = { ...prev };
        delete next[name]; // <— clear any old error
        return next;
      });
      const sasUri = sessionStorage.getItem("blobToken");
      const fd = new FormData();
      fd.append("image", file, file.name);
      fd.append("sasUri", sasUri);
      const uploaded = await uploadImage(fd);
      const uploadedUrl =
        typeof uploaded === "string"
          ? uploaded
          : uploaded?.blobName || uploaded?.link || "";
      //       if (!uploadedUrl) throw new Error("Upload did not return a URL");
      //       const url = new URL(uploadedUrl);
      //       const pathname = url.pathname.substring(1);
      //       const search = url.search;
      //       const desiredPart = pathname + search;
      const desiredPart = uploadedUrl;
      setFormData((prev) => ({ ...prev, [name]: { file, url: uploadedUrl } }));
      setmodifiedData((prev) => ({ ...prev, [name]: desiredPart }));
      setMessage((prev) => ({ ...prev, [name]: "Uploaded successfully" }));
      setErrors((prev) => {
        const next = { ...prev };
        delete next[name]; // <— clear again on success
        return next;
      });
    } catch (err) {
      console.error(err);
      setMessage((prev) => ({ ...prev, [name]: "" }));
      setErrors((prev) => ({ ...prev, [name]: "Upload failed" }));
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setmodifiedData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => (prev?.[name] ? { ...prev, [name]: null } : prev));
  };

  const openCountryModal = (field) => {
    const fid = String(field.id ?? field.fieldId);
    setTargetId(fid);
    setOriginalValue(field.value ?? formData[fid] ?? "");
    setDidPick(false);
    setModalMode("COUNTRIES");
    setModalShow(true);
  };

  const fieldsIndex = useMemo(
    () =>
      Object.fromEntries(
        (getfieldByStepId?.fields ?? []).map((f) => [Number(f.id), f])
      ),
    [getfieldByStepId]
  );

  const linkedParentByChild = useMemo(() => {
    const byId = Object.fromEntries(
      (getfieldByStepId?.fields ?? []).map((f) => [Number(f.id), f])
    );

    const m = {};
    (getfieldByStepId?.fields ?? []).forEach((parent) => {
      if (Number(parent.type) !== 22 || !Array.isArray(parent.linkedFields))
        return;

      parent.linkedFields.forEach((childIdRaw) => {
        const childId = Number(childIdRaw);
        // Map the direct child (e.g., 160) to the parent (e.g., 118)
        if (m[childId] == null) m[childId] = Number(parent.id);

        // If the direct child is a radio (type 5), map its nested fields too
        const childField = byId[childId];
        if (
          childField &&
          Number(childField.type) === 5 &&
          Array.isArray(childField.options)
        ) {
          childField.options.forEach((opt) => {
            (opt.nestedFields || []).forEach((nf) => {
              const nfId = Number(nf);
              if (m[nfId] == null) m[nfId] = Number(parent.id);
            });
          });
        }
      });
    });
    return m;
  }, [getfieldByStepId]);

  const baseIdStr = (id) => String(id).split("_")[0];
  const baseIdNum = (id) => Number(baseIdStr(id));

  // key: "120" (original block) => ordinal 1
  // key: "120_1" (first clone)   => ordinal 2, etc.
  const groupOrdinalFromKey = (key) => {
    const parts = String(key).split("_");
    return parts.length > 1 ? Number(parts[1]) + 1 : 1;
  };

  const computeGroupIdForKey = (key) => {
    const child = baseIdNum(key);
    const parent = linkedParentByChild[child];
    if (!parent) return ""; // non-linked fields keep empty groupId
    const ordinal = groupOrdinalFromKey(key);
    return `${parent}_${ordinal}`;
  };

  const commonProps = {
    allcountries,
    formData,
    errors,
    removeShareholder,
    setErrors,
    setFormData,
    handleInputChange,
    handleUploadChange,
    setModalTitle,
    setModalDes,
    setModalShow,
    infoShowing,
    setInfoShowing,
    shareholder,
    setShareHolder,
    modalMode,
    setModalMode,
    setModalPayload,
    openCountrySlot,
    outsideSelections,
    setOutsideSelections,
    openCountryModal,
    fieldsIndex,
    extraOwners,
    setExtraOwners,
    addShareholder,
    cloneForOwner,
    ownerIdxMap,
    countries,
    message,
    setOwnerIdxMap,
    setmodifiedData,
  };

  const isEmpty = (f, v) => {
    if (v === undefined || v === null) return true;
    if (typeof v === "string" && v.trim() === "") return true;
    if (f.type === 9) return v === "";
    if (f.type === 21) {
      const hasFile = v?.file?.name;
      const hasName = v?.name;
      const hasUrl = typeof v === "string" ? v : v?.url;
      return !(hasFile || hasName || hasUrl);
    }
    if (f.type === 20 && typeof v === "object")
      return Object.values(v).join("").trim() === "";
    return false;
  };

  //   const validateMandatory = (fields, data) =>
  //     fields.reduce((errs, f) => {
  //       const id = String(f.id ?? f.fieldId);
  //       if (f.isMandatory && isEmpty(f, data[id])) errs[id] = "Required";
  //       return errs;
  //     }, {});

  // --- Helpers (put these above validateMandatory) ---

  // get all suffixes for a type-22 parent: "" for the original block, then "_1","_2",...
  const getOrdSuffixesForParent = (parentId) => {
    const sfxes = ownerIdxMap?.[parentId] || [];
    // store just the number as string for composing keys
    return ["", ...sfxes.map(String)];
  };

  // compose a key for a given base id and suffix
  const keyFor = (id, sfx) => (sfx ? `${id}_${sfx}` : String(id));

  // find the (single) type-22 parent that links a given child id
  const parent22Of = (childId) => {
    // We already have fieldsIndex in scope
    for (const f of Object.values(fieldsIndex || {})) {
      if (
        Number(f?.type) === 22 &&
        (f.linkedFields || []).includes(Number(childId))
      ) {
        return Number(f.id);
      }
    }
    return null;
  };

  // Build the set of ACTIVE nested keys to validate, across ALL ordinals of 118 (and any other type-22 referenced)
  const collectActiveNestedKeys = (data) => {
    const keys = new Set();

    const radioDef = fieldsIndex?.[160];
    if (!radioDef) return keys;

    // parent that hosts 160 (usually 118)
    const parentOf160 = parent22Of(160);
    const ordSfxes = parentOf160 ? getOrdSuffixesForParent(parentOf160) : [""];

    ordSfxes.forEach((sfx) => {
      const radioKey = keyFor(160, sfx);
      const selected = String(data?.[radioKey] ?? "");
      if (!selected) return; // this 160 instance itself will be validated below as required if needed

      const selOpt = (radioDef.options || []).find(
        (o) => String(o.optionId) === selected
      );
      const nestedList = selOpt?.nestedFields || [];

      nestedList.forEach((nid) => {
        const def = fieldsIndex?.[Number(nid)];
        if (!def) return;

        if (Number(def.type) === 22) {
          // if the branch includes another group (e.g., 118 or 191),
          // validate ALL of that group's ordinals (original + clones)
          const grpId = Number(def.id);
          const grpSfxes = getOrdSuffixesForParent(grpId);
          (def.linkedFields || []).forEach((childId) => {
            grpSfxes.forEach((gsfx) => {
              keys.add(keyFor(childId, gsfx));
            });
          });
        } else {
          // normal field: validate the field for THIS shareholder ordinal
          keys.add(keyFor(nid, sfx));
        }
      });
    });

    return keys;
  };

  // --- REPLACE your validateMandatory with this version ---
  const EXEMPT_IDS = new Set([134, 137, 161]); // keep yours

const validateMandatory = (fields, data) => {
  const errs = {};
  const dataKeys = Object.keys(data || {});

  // 1) Non-nested required fields (base keys only)
  fields.forEach((f) => {
    const idNum = Number(f.id ?? f.fieldId);
    const idStr = String(idNum);
    if (
      !f.isNestedField &&            // top-level only
      f.isMandatory &&
      !EXEMPT_IDS.has(idNum) &&
      isEmpty(f, data[idStr])
    ) {
      errs[idStr] = "Required";
    }
  });

  // 2) Ensure every 160 instance (base + suffixed) is filled if mandatory
  //    (160 clones usually live under a repeater as 160_1, 160_2, …)
  const radioDef = fieldsIndex?.[160];
  if (radioDef?.isMandatory) {
    const p160 = parent22Of(160);
    const sfxes = p160 ? getOrdSuffixesForParent(p160) : [""];
    sfxes.forEach((sfx) => {
      const rKey = keyFor(160, sfx);
      const v = String(data?.[rKey] ?? "");
      if (!v) errs[rKey] = "Required";
    });
  }

  // 3) Nested fields: ONLY those that belong to the selected branch(es), across ALL ordinals
  const activeKeys = collectActiveNestedKeys(data);
  activeKeys.forEach((key) => {
    const base = Number(String(key).split("_")[0]);
    const def = fieldsIndex?.[base];
    if (!def) return;
    if (
      def.isMandatory &&
      !EXEMPT_IDS.has(base) &&
      isEmpty(def, data?.[key])
    ) {
      errs[key] = "Required";
    }
  });

  // 4) Email format validation (type 13 + id 127) — validate base + ALL clones by scanning data keys
  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

  // Collect the base IDs that should be treated as email
  const emailBaseIds = new Set();
  fields.forEach((f) => {
    const idNum = Number(f.id ?? f.fieldId);
    // treat as email if type === 13, and always for id 127
    if (Number(f.type) === 13 || idNum === 127) {
      emailBaseIds.add(idNum);
    }
  });

  // For each email base id, validate all keys that match ^<id>(_\d+)?$
  emailBaseIds.forEach((baseId) => {
    const keyRegex = new RegExp(`^${baseId}(?:_\\d+)?$`);
    dataKeys.forEach((k) => {
      if (!keyRegex.test(String(k))) return;
      const raw = String(data?.[k] ?? "").trim();
      // Only check format if user typed something (emptiness handled by required rules)
      if (raw && !EMAIL_RE.test(raw)) {
        errs[k] = "Please enter a valid email address.";
      }
    });
  });

  return errs;
};

  const buildFormattedData = () => {
    const list = [];

    for (const [fid, val] of Object.entries(modifiedData)) {
      if (val === "2") {
        const picks = (outsideSelections[fid] || []).filter(Boolean); // max 3
        picks.forEach((c) =>
          list.push({ id: Number(fid), value: String(c.id) })
        );

        if (!picks.length) list.push({ id: Number(fid), value: val });
      } else {
        list.push({ id: Number(fid), value: val });
      }
    }

    return list;
  };

  const handleSaveAndNext = async () => {
    const step = currentStepId;
    const currentFields = getfieldByStepId?.fields || [];
    const errs = validateMandatory(currentFields, formData);
    setErrors(errs);
    setShareHolder(false);
  
    // --- Ownership % safety (kept as-is) ---
    {
      const parsePct = (v) => {
        const n =
          typeof v === "string" ? Number(v.replace(/[^\d.]/g, "")) : Number(v);
        return Number.isFinite(n) ? n : 0;
      };
  
      const OWNERSHIP_BASE_IDS = [119, 193];
      const SKIP_STEP = 24;
  
      // Sum across *all* ownership fields (119 & 193) and *all* groups (119_1, 193_2, …)
      const sumAllOwnership = Object.entries(formData).reduce((acc, [k, v]) => {
        return OWNERSHIP_BASE_IDS.includes(baseIdNum(k)) ? acc + parsePct(v) : acc;
      }, 0);
  
      if (sumAllOwnership > 100 && currentStepId !== SKIP_STEP) {
        setErrors((prev) => {
          const next = { ...(prev || {}) };
          OWNERSHIP_BASE_IDS.forEach((id) => {
            next[String(id)] = "Total ownership across all owners exceeds 100%";
          });
          return next;
        });
  
        if (step != 28) {
          const el =
            document.getElementById("error-119") ||
            document.getElementById("error-193");
          setTimeout(() => {
            el?.closest("div, form, section")?.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }, 100);
          return; // stop save
        }
      } else {
        // clear previous combined error if any
        setErrors((prev) => {
          const next = { ...(prev || {}) };
          OWNERSHIP_BASE_IDS.forEach((id) => delete next[String(id)]);
          return next;
        });
      }
    }
  
    // --- Generic validation scroll (kept as-is) ---
    {
      if (Object.keys(errs).length && step != 28) {
        const errorIds = [
          119, 120, 121, 122, 123, 124, 125, 126, 127, 187, 188, 189, 190, 191,
        ];
        const errorKeys = Object.keys(errs);
        // Check if any of the error keys match the special list
        const hasSpecialIds = errorKeys.some((id) => errorIds.includes(Number(id)));
        // Check if any key ends with _1 → _9
        const hasUnderscoreIds = errorKeys.some((id) => /_(?:[1-9])$/.test(id));
        // Decide which ID to scroll to
        let firstErrorId;
        if (hasSpecialIds || hasUnderscoreIds) {
          firstErrorId = 160;
        } else {
          firstErrorId = Number(errorKeys[0]);
        }
        const el = document.getElementById(`error-${firstErrorId}`);
        setTimeout(() => {
          if (el) {
            const scrollTarget = el.closest("div, form, section");
            if (scrollTarget) {
              scrollTarget.scrollIntoView({
                behavior: "smooth",
                block: "center",
              });
            }
          }
        }, 10);
        return;
      }
    }
  
    try {
      if (step === 28) {
        // await CorporateAutoFillData(true);
        await SaveCorporateEnrollmentEntityData(
          verificationid,
          corporatedata?.corporateDocuments,
          remoteId
        );
      } else {
        const needsExpansion = modifiedData["139"] === "2";
  
        // -------------------------------
        // SPECIAL CASE: Countries (id 179)
        // If any 179 key changed, send the FULL set for that group.
        // -------------------------------
        const changed179Keys = Object.keys(modifiedData).filter(
          (k) => baseIdNum(k) === 179
        );
  
        const formattedCountry = changed179Keys.map((k) => {
          const arr = normalizeToArray(formData[k] ?? modifiedData[k]); // current full state
          const value = arr.filter(Boolean).join(","); // e.g. "3,74,39"
          return {
            id: 179,
            value,
            groupId: computeGroupIdForKey(k),
            statusId: 1,
          };
        });
  
        // The rest of the fields (skip 179* to avoid duplicates)
        const formattedRest = Object.entries(modifiedData).flatMap(
          ([key, val]) => {
            if (baseIdNum(key) === 179) return [];
  
            const id = baseIdNum(key);
            const groupId = computeGroupIdForKey(key);
  
            if (Number(key) === 185) {
              sessionStorage.setItem("applyToIban", String(val ?? ""));
            }
  
            if (Array.isArray(val)) {
              return val
                .filter(
                  (v) =>
                    v != null && !(typeof v === "string" && v.trim() === "")
                )
                .map((v) => ({
                  id,
                  value: String(v),
                  groupId,
                  statusId: 1,
                }));
            }
  
            return [
              {
                id,
                value: String(val ?? ""),
                groupId,
                statusId: 1, // default statusId to 1
              },
            ];
          }
        );
  
        const formattedData = [...formattedCountry, ...formattedRest];
  
        await SaveFieldValue(formattedData, step, verificationid);
      }
    } finally {
      dispatch(settingData({ field: "corporatedata", value: null }));
      setOwnerIdxMap({});
      handleNext();
    }
  };

  const isLegalDocsTitle = (f) =>
    (f.type === 3 || f.type === 4) &&
    /legal\s*documents?/i.test((f.title || "").trim());

  const isEmployeeLimitsTitle = (f) =>
    (f.type === 3 || f.type === 4) &&
    /employee\s*limits\s*per\s*access\s*level/i.test((f.title || "").trim());

  const skipIds = useMemo(() => {
    const s = new Set();
    (getfieldByStepId?.fields ?? []).forEach((f) => {
      if (f.type === 22 && Array.isArray(f.linkedFields)) {
        f.linkedFields.forEach((id) => {
          if (id !== 160) s.add(id);
        });
      }
    });
    return s;
  }, [getfieldByStepId]);

  const renderStepFields = (fields = []) => {
    const els = [];
    for (let i = 0; i < fields.length; i++) {
      const raw = fields[i];
      const f = norm(raw);
      if (skipIds.has(raw.id)) continue;
      if (raw.isNestedField) continue;

      if (isLegalDocsTitle(f)) {
        els.push(
          <React.Fragment key={`title-${String(f.id)}`}>
            {renderField({ field: f, ...commonProps })}
          </React.Fragment>
        );

        const uploads = [];
        let j = i + 1;

        while (j < fields.length) {
          const nextRaw = fields[j];
          const nf = norm(nextRaw);

          if (nf.type === 21) {
            // Only include standalone uploads (not nested and not children of a repeater)
            if (!skipIds.has(nf.id) && !nf.isNestedField) {
              uploads.push(
                <React.Fragment key={`upload-${String(nf.id)}`}>
                  {renderField({ field: nf, ...commonProps })}
                </React.Fragment>
              );
            }
            j++; // keep scanning consecutive type-21s
            continue;
          }

          break; // stop batching when the next field isn't an upload
        }

        els.push(
          <div
            className="legal-docs-upload-group"
            key={`uploads-group-${String(f.id)}`}
          >
            {uploads}
          </div>
        );

        i = j - 1;
        continue;
      }

      if (isEmployeeLimitsTitle(f)) {
        els.push(
          <React.Fragment key={`title-${String(f.id)}`}>
            {renderField({ field: f, ...commonProps })}
          </React.Fragment>
        );

        let j = i + 1;
        let chunk = [];

        const flushChunk = (keyPrefix) => {
          if (!chunk.length) return;
          els.push(
            <div className="employee-limits-grid" key={`${keyPrefix}-grid`}>
              {chunk}
            </div>
          );
          chunk = [];
        };

        while (j < fields.length) {
          const nf = norm(fields[j]);

          if (nf.type === 3 || nf.type === 22) break;

          if (nf.type === 4) {
            flushChunk(`emp-limits-${String(nf.id)}-before`);
            els.push(
              <React.Fragment key={`emp-limits-sub-${String(nf.id)}`}>
                {renderField({ field: nf, ...commonProps })}
              </React.Fragment>
            );
            j++;
            continue;
          }

          chunk.push(
            <React.Fragment key={`emp-limits-item-${String(nf.id)}`}>
              {renderField({ field: nf, ...commonProps })}
            </React.Fragment>
          );

          j++;
        }

        flushChunk(`emp-limits-end-${String(f.id)}`);

        i = j - 1;
        continue;
      }

      els.push(
        <React.Fragment key={String(f.id ?? f.fieldId)}>
          {renderField({ field: f, ...commonProps })}
        </React.Fragment>
      );
    }
    return els;
  };

  const goToFirstStep = () => {
    dispatch(settingData({ field: "stepid", value: initialStepId }));
    setRerender(initialStepId);
  };

  const orderedFields = useMemo(() => {
    const arr = (getfieldByStepId?.fields ?? [])
      .filter((f) => !f?.isNestedField)
      .map((f, i) => ({
        ...f,
        __idx: i,
        __order: Number(f.orderId ?? 0),
      }));

    const sorted = [...arr].sort(
      (a, b) =>
        a.__order - b.__order ||
        Number(a.id ?? a.fieldId) - Number(b.id ?? b.fieldId) ||
        a.__idx - b.__idx
    );

    const idx160 = sorted.findIndex((f) => Number(f.id ?? f.fieldId) === 160);
    const has118 = sorted.some((f) => Number(f.id ?? f.fieldId) === 118);
    if (idx160 !== -1 && has118) {
      sorted.splice(idx160, 1);
    }

    return sorted.map(({ __idx, __order, ...rest }) => rest);
  }, [getfieldByStepId]);

  function normalizeToArray(val, size = 3) {
    if (Array.isArray(val)) return [...val];
    if (typeof val === "string") {
      return val.split(",").map((x) => (x === "" ? null : x));
    }
    return Array(size).fill(null);
  }

  return (
    <>
      <div className="form-template ownership-profile-root">
        <div className="form-container">
          {currentStepId !== 28 &&
            corporatedata &&
            Object.entries(corporatedata?.groupedFields || {})
              .filter(([section]) => section === "COMPANY PROFILE")
              .map(([section, fields]) => {
                const sortedFields = [...(fields || [])].sort(
                  (a, b) => (a.orderId ?? 0) - (b.orderId ?? 0)
                );

                // First, group by groupId (if present), else fallback to orderId
                const grouped = sortedFields.reduce((acc, f) => {
                  const key = f.groupId
                    ? `g-${f.groupId}`
                    : `o-${f.orderId ?? 0}`;
                  if (!acc[key]) acc[key] = [];
                  acc[key].push(f);
                  return acc;
                }, {});

                return (
                  <React.Fragment key={section}>
                    <div className="form-title margin-left-width">
                      {section}
                    </div>
                    <div className="margin-left-width mb-4">
                      {Object.entries(grouped).map(([key, group]) => {
                        if (key.startsWith("g-")) {
                          // GroupId: render vertically
                          return (
                            <div key={key} className="form-group-vertical">
                              {group.map((f) => (
                                <div key={String(f.id ?? f.fieldId)}>
                                  {renderFieldCompany({
                                    field: norm(f),
                                    formData,
                                    errors,
                                    setErrors,
                                    setFormData,
                                    handleInputChange,
                                    setModalMode,
                                    setModalTitle,
                                    setModalDes,
                                    setModalShow,
                                    infoShowing,
                                    setInfoShowing,
                                  })}
                                </div>
                              ))}
                            </div>
                          );
                        } else if (group.length > 1) {
                          return (
                            <div key={key}>
                              {group.map((f) => (
                                <div
                                  key={String(f.id ?? f.fieldId)}
                                  className="form-group--half"
                                >
                                  {renderFieldCompany({
                                    field: norm(f),
                                    formData,
                                    errors,
                                    setErrors,
                                    setFormData,
                                    handleInputChange,
                                    setModalMode,
                                    setModalTitle,
                                    setModalDes,
                                    setModalShow,
                                    infoShowing,
                                    setInfoShowing,
                                  })}
                                </div>
                              ))}
                            </div>
                          );
                        }
                        return group.map((f) => (
                          <React.Fragment key={String(f.id ?? f.fieldId)}>
                            {renderFieldCompany({
                              field: norm(f),
                              formData,
                              errors,
                              setErrors,
                              setFormData,
                              handleInputChange,
                              setModalMode,
                              setModalTitle,
                              setModalDes,
                              setModalShow,
                              infoShowing,
                              setInfoShowing,
                            })}
                          </React.Fragment>
                        ));
                      })}
                    </div>
                  </React.Fragment>
                );
              })}

          {currentStepId !== 28 && renderStepFields(orderedFields)}

          {currentStepId === 28 &&
            finalStep?.groupedFields &&
            Object.entries(finalStep.groupedFields).map(([section, fields]) => {
              // 1) Normalize to flat array
              const list = Array.isArray(fields)
                ? fields
                : Array.isArray(fields?.fields)
                ? fields.fields
                : fields && typeof fields === "object"
                ? Object.values(fields)
                : [];

              // 2) Split by groupID
              const grouped = [];
              const ungrouped = [];
              for (const f of list) {
                const gid = f.groupID ?? null; // API uses groupID
                if (gid) grouped.push(f);
                else ungrouped.push(f);
              }

              // 3) Build grouped blocks: group by gid, sort fields in group by orderId, compute anchor (min orderId)
              const groupedByGroupID = grouped.reduce((acc, f) => {
                (acc[f.groupID] ||= []).push(f);
                return acc;
              }, {});
              const groupBlocks = Object.entries(groupedByGroupID).map(
                ([gid, arr]) => {
                  const gf = [...arr].sort(
                    (a, b) => (a.orderId ?? 0) - (b.orderId ?? 0)
                  );
                  const anchor = Math.min(
                    ...gf.map((x) => Number(x.orderId ?? 0))
                  );
                  return { kind: "group", gid, fields: gf, orderId: anchor };
                }
              );

              // 4) Build ungrouped blocks (each item is its own block)
              const ungroupedBlocks = ungrouped
                .map((f) => ({
                  kind: "item",
                  field: f,
                  orderId: Number(f.orderId ?? 0),
                }))
                // keep ungrouped sorted among themselves so ties are stable
                .sort((a, b) => a.orderId - b.orderId);

              // 5) Merge + global sort by orderId, with a deterministic tie-breaker
              const blocks = [...ungroupedBlocks, ...groupBlocks].sort(
                (a, b) => {
                  if (a.orderId !== b.orderId) return a.orderId - b.orderId;
                  // put groups before items on identical orderId (or flip if you prefer)
                  if (a.kind !== b.kind) return a.kind === "group" ? -1 : 1;
                  // final tie-breaker: by gid/fieldId
                  const aKey = a.kind === "group" ? a.gid : a.field?.fieldId;
                  const bKey = b.kind === "group" ? b.gid : b.field?.fieldId;
                  return String(aKey ?? "").localeCompare(String(bKey ?? ""));
                }
              );

              return (
                <React.Fragment key={`final-${section}`}>
                  <div className="form-title margin-left-width">{section}</div>

                  <div className="margin-left-width">
                    {(() => {
                      const out = [];
                      let pendingGroupRow = [];

                      const flushGroupRowInline = () => {
                        if (!pendingGroupRow.length) return;
                        const rowIdx = out.length; // only for key uniqueness
                        out.push(
                          <div
                            key={`grouprow-${rowIdx}`}
                            className="form-group-row"
                          >
                            {pendingGroupRow.map(
                              ({ gid, fields: groupFields }, colIdx) => (
                                <div
                                  key={`${gid}-${colIdx}`}
                                  className="form-group--col"
                                >
                                  {groupFields.map((f, i) => {
                                    // unique id per group occurrence to avoid collisions
                                    const [_p, o] = String(gid).split("_");
                                    const baseId = String(
                                      f.id ?? f.fieldId ?? `${gid}-${i}`
                                    );
                                    const uniqueId = o
                                      ? `${baseId}_${Number(o) - 1}`
                                      : baseId;

                                    const idKey = String(f.id ?? f.fieldId);
                                    const formDataForThis = {
                                      ...formData,
                                      [idKey]: f.value,
                                    };

                                    return renderFieldCompany({
                                      ...commonProps,
                                      formData: formDataForThis,
                                      field: norm({
                                        ...f,
                                        id: uniqueId,
                                        isNestedField: false, // force visible in review
                                      }),
                                    });
                                  })}
                                </div>
                              )
                            )}
                          </div>
                        );
                        pendingGroupRow = [];
                      };

                      // Walk blocks IN ORDER; emit items and group rows inline
                      for (let i = 0; i < blocks.length; i++) {
                        const b = blocks[i];

                        if (b.kind === "item") {
                          // item is full-width => flush any pending groups first
                          flushGroupRowInline();

                          const f = b.field;
                          const idKey = String(f.id ?? f.fieldId);
                          const formDataForThis = {
                            ...formData,
                            [idKey]: f.value,
                          };

                          out.push(
                            <React.Fragment
                              key={`ung-${f.fieldValueId ?? f.fieldId ?? i}`}
                            >
                              {renderFieldCompany({
                                ...commonProps,
                                formData: formDataForThis,
                                field: norm({
                                  ...f,
                                  id: idKey,
                                  isNestedField: false, // force visible in review
                                }),
                              })}
                            </React.Fragment>
                          );
                        } else {
                          // collect up to 2 groups per row
                          pendingGroupRow.push(b);
                          if (pendingGroupRow.length === 2) {
                            flushGroupRowInline();
                          }
                        }
                      }

                      // flush any trailing group row
                      flushGroupRowInline();

                      return out;
                    })()}
                  </div>
                </React.Fragment>
              );
            })}

          {currentStepId === 28 && <div style={{ marginTop: "5rem" }}></div>}

          {currentStepId === 28 &&
            Array.isArray(finalStep?.corporateDocuments) && (
              <div className="form-field box-image-last-step margin-left-width">
                <p cl className="form-title" ass>
                  Legal Documents
                </p>
                {finalStep.corporateDocuments.map((doc, i) =>
                  renderFieldCompanyImages({
                    field: {
                      id: doc.id ?? doc.fieldId ?? doc.documentType ?? i,
                      ...doc,
                    },
                    errors,
                  })
                )}
              </div>
            )}

          {currentStepId === 28 && (
            <div className="buttoncontianer">
              <button
                className="continue-btn"
                onClick={goToFirstStep}
                style={{
                  marginBottom: "25px",
                  backgroundColor: "white",
                  color: "black",
                  border: "1px solid black",
                }}
              >
                Edit
              </button>
            </div>
          )}

          <div className="buttoncontianer">
            <button
              className="continue-btn"
              onClick={() => handleSaveAndNext()}
            >
              Continue
            </button>
          </div>
        </div>
      </div>

      {modalShow && modalMode === "COUNTRIES" && (
        <CountryTransferPopup
          formData={formData}
          isOpen={modalShow}
          onClose={() => {
            if (modalPayload?.type !== "outsideCountry") {
              if (!didPick && targetId != null) {
                setFormData((p) => ({ ...p, [targetId]: originalValue }));
                setmodifiedData((p) => {
                  const copy = { ...p };
                  delete copy[targetId];
                  return copy;
                });
              }
            }
            setModalShow(false);
          }}
          countries={countries}
          onPick={(c) => {
            if (modalPayload?.type === "outsideCountry") {
              const fid = modalPayload.fieldId;
              const idx = modalPayload.slotIndex ?? 0;

              // Track selected objects for display
              setOutsideSelections((prev) => {
                const prevArr = prev[fid] || [null, null, null];
                const nextArr = [...prevArr];
                nextArr[idx] = c
                  ? {
                      id: c.id ?? c.code,
                      name: c.name ?? c.label ?? String(c.id ?? c.code),
                    }
                  : null;
                return { ...prev, [fid]: nextArr };
              });

              if (c) {
                const v = String(c.id ?? c.code);

                setFormData((p) => {
                  const prevArr = normalizeToArray(p[fid]);
                  const nextArr = [...prevArr];
                  nextArr[idx] = v;
                  return { ...p, [fid]: nextArr };
                });

                setmodifiedData((p) => {
                  const prevArr = normalizeToArray(p[fid]);
                  const nextArr = [...prevArr];
                  nextArr[idx] = v;
                  return { ...p, [fid]: nextArr };
                });
              }

              setDidPick(true);
              setModalShow(false);
              return;
            }

            // --- Non-outsideCountry case ---
            if (c && targetId) {
              const v = String(c.id ?? c.code);

              setFormData((p) => {
                const prevArr = Array.isArray(p[targetId])
                  ? p[targetId]
                  : [null, null, null];
                const nextArr = [...prevArr];
                // by default, use slot 0 for non-outsideCountry
                nextArr[0] = v;
                return { ...p, [targetId]: nextArr };
              });

              setmodifiedData((p) => {
                const prevArr = Array.isArray(p[targetId])
                  ? p[targetId]
                  : [null, null, null];
                const nextArr = [...prevArr];
                nextArr[0] = v;
                return { ...p, [targetId]: nextArr };
              });

              setDidPick(true);
            }

            setModalShow(false);
          }}
        />
      )}
    </>
  );
}

export default FormsTemplate;
